import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getHttp } from 'src/api'
import { PATH_API } from 'src/helpers'
import { useAppContext } from 'src/helpers/app'
import { SegmentAction, segmentTracking } from 'src/helpers/segment'
import { API, IQuizSessionsResponse } from 'src/types'

export const useCallScheduler = () => {
  const { sessionId } = useParams<{ sessionId: string }>()
  const { handleChangeAppData, setSessionID, setQuizSession, quizSession } = useAppContext()

  useEffect(() => {
    const initPage = async () => {
      if (sessionId) segmentTracking(SegmentAction.SQ_CV_SCHEDULE_CALL_STARTED)
      if (!sessionId || quizSession) return

      handleChangeAppData({ countLoading: 1 })
      try {
        const sessionResult: API<IQuizSessionsResponse> = await getHttp(PATH_API.getSessionId(sessionId))
        setQuizSession(sessionResult.data)
        setSessionID(sessionId)
      } catch (error) {
        console.error('initPage', error)
      }
      handleChangeAppData({ countLoading: -1 })
    }

    initPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId])

  return {}
}
